import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS TRABALHISTAS
// ============================================

// Alegações Finais Trabalhista
export const ALEGACOES_FINAIS_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Alegações Finais (Trabalhista)',
  description: 'Peça para apresentar alegações finais em processo trabalhista',
  suggestedDocs: 'Contestação, Petição inicial, Processo na íntegra e Réplica.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Indique sobre qual parte do processo deseja fazer alegações',
  infoTip: 'Nas alegações finais, sintetize os principais argumentos e provas produzidas em favor do seu cliente.',
};
export const AlegacoesFinaisTrabalhistaForm = createFormFromConfig(ALEGACOES_FINAIS_TRABALHISTA_CONFIG);

// Embargos de Declaração Trabalhista
export const EMBARGOS_DECLARACAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos de Declaração (Trabalhista)',
  description: 'Peça para esclarecer obscuridade, eliminar contradição ou suprir omissão em decisão trabalhista',
  suggestedDocs: 'Decisão judicial e Processo na íntegra.',
  defaultPecaRebater: 'Decisão judicial',
  pecaRebaterHelper: 'Informe a decisão que contém obscuridade, contradição ou omissão',
  infoTip: 'Nos embargos de declaração, seja específico sobre os pontos obscuros, contraditórios ou omissos da decisão.',
};
export const EmbargosDeclaracaoTrabalhistaForm = createFormFromConfig(EMBARGOS_DECLARACAO_TRABALHISTA_CONFIG);

// Contrarrazões ao Recurso de Revista
export const CONTRARRAZOES_RR_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso de Revista',
  description: 'Peça para responder ao Recurso de Revista interposto pela parte contrária',
  suggestedDocs: 'Acórdão, Processo na íntegra e Recurso de Revista.',
  defaultPecaRebater: 'Recurso de Revista',
  pecaRebaterHelper: 'Indique o Recurso de Revista que deseja contrarrazoar',
  infoTip: 'Nas contrarrazões, demonstre que o acórdão está em conformidade com a lei e jurisprudência do TST.',
};
export const ContrarrazoesRRForm = createFormFromConfig(CONTRARRAZOES_RR_CONFIG);

// Agravo de Instrumento Trabalhista
export const AGRAVO_INSTRUMENTO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo de Instrumento (Trabalhista)',
  description: 'Recurso contra decisão interlocutória no processo trabalhista',
  suggestedDocs: 'Agravo de instrumento, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Interlocutória',
  pecaRebaterHelper: 'Informe a decisão interlocutória que deseja agravar',
  infoTip: 'No agravo de instrumento, demonstre o erro da decisão interlocutória e o prejuízo causado à parte.',
};
export const AgravoInstrumentoTrabalhistaForm = createFormFromConfig(AGRAVO_INSTRUMENTO_TRABALHISTA_CONFIG);

// Mandado de Segurança Trabalhista
export const MANDADO_SEGURANCA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Mandado de Segurança (Trabalhista)',
  description: 'Ação para proteger direito líquido e certo violado por ato de autoridade no âmbito trabalhista',
  suggestedDocs: 'Decisão atacada, provas do direito líquido e certo.',
  infoTip: 'No mandado de segurança, demonstre claramente o direito líquido e certo e a ilegalidade ou abuso de poder.',
};
export const MandadoSegurancaTrabalhistaForm = createFormFromConfig(MANDADO_SEGURANCA_TRABALHISTA_CONFIG);

// Impugnação à Sentença de Liquidação Trabalhista
export const IMPUGNACAO_LIQUIDACAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Sentença de Liquidação (Trabalhista)',
  description: 'Peça para impugnar os cálculos de liquidação em processo trabalhista',
  suggestedDocs: 'Planilha de cálculos, Sentença de liquidação e Processo na íntegra.',
  defaultPecaRebater: 'Sentença de Liquidação',
  pecaRebaterHelper: 'Informe a sentença de liquidação que deseja impugnar',
  infoTip: 'Na impugnação, aponte especificamente os erros nos cálculos e apresente os valores corretos.',
};
export const ImpugnacaoLiquidacaoTrabalhistaForm = createFormFromConfig(IMPUGNACAO_LIQUIDACAO_TRABALHISTA_CONFIG);

// Exceção de Incompetência Trabalhista
export const EXCECAO_INCOMPETENCIA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Exceção de Incompetência (Trabalhista)',
  description: 'Peça para arguir a incompetência do juízo trabalhista',
  suggestedDocs: 'Reclamação trabalhista e documentos que comprovem a incompetência.',
  defaultPecaRebater: 'Reclamação Trabalhista',
  pecaRebaterHelper: 'Informe a peça inicial que tramita no juízo incompetente',
  infoTip: 'Na exceção de incompetência, demonstre qual é o juízo competente para processar a demanda.',
};
export const ExcecaoIncompetenciaTrabalhistaForm = createFormFromConfig(EXCECAO_INCOMPETENCIA_TRABALHISTA_CONFIG);

// Impugnação ao Valor da Causa Trabalhista
export const IMPUGNACAO_VALOR_CAUSA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação ao Valor da Causa (Trabalhista)',
  description: 'Peça para impugnar o valor atribuído à causa trabalhista',
  suggestedDocs: 'Reclamação trabalhista e documentos que demonstrem o valor correto.',
  defaultPecaRebater: 'Reclamação Trabalhista',
  pecaRebaterHelper: 'Informe a petição inicial com valor incorreto',
  infoTip: 'Na impugnação, demonstre o valor correto da causa com base nos pedidos formulados.',
};
export const ImpugnacaoValorCausaTrabalhistaForm = createFormFromConfig(IMPUGNACAO_VALOR_CAUSA_TRABALHISTA_CONFIG);

// Ação de Cumprimento Trabalhista
export const ACAO_CUMPRIMENTO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Ação de Cumprimento (Trabalhista)',
  description: 'Ação para exigir o cumprimento de sentença normativa ou acordo coletivo',
  suggestedDocs: 'Acordo ou convenção coletiva, documentos que comprovem descumprimento.',
  infoTip: 'Na ação de cumprimento, demonstre claramente quais cláusulas foram descumpridas e os prejuízos causados.',
};
export const AcaoCumprimentoTrabalhistaForm = createFormFromConfig(ACAO_CUMPRIMENTO_TRABALHISTA_CONFIG);

// Habeas Corpus Trabalhista
export const HABEAS_CORPUS_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Habeas Corpus (Trabalhista)',
  description: 'Ação para cessar constrangimento ilegal à liberdade de locomoção no âmbito trabalhista',
  suggestedDocs: 'Decisão que determinou prisão ou ameaça de prisão.',
  infoTip: 'No habeas corpus trabalhista, demonstre a ilegalidade da prisão ou ameaça de prisão civil.',
};
export const HabeasCorpusTrabalhistaForm = createFormFromConfig(HABEAS_CORPUS_TRABALHISTA_CONFIG);

// Agravo Regimental Trabalhista
export const AGRAVO_REGIMENTAL_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo Regimental (Trabalhista)',
  description: 'Recurso contra decisão monocrática no processo trabalhista',
  suggestedDocs: 'Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Decisão monocrática',
  pecaRebaterHelper: 'Informe a decisão monocrática que deseja agravar',
  infoTip: 'No agravo regimental, demonstre o erro da decisão monocrática e por que deve ser reformada pelo colegiado.',
};
export const AgravoRegimentalTrabalhistaForm = createFormFromConfig(AGRAVO_REGIMENTAL_TRABALHISTA_CONFIG);

// Embargos para a SDI 1 do TST
export const EMBARGOS_SDI_TST_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos para a SDI 1 do TST',
  description: 'Recurso para a Seção de Dissídios Individuais do TST em caso de divergência jurisprudencial',
  suggestedDocs: 'Decisão embargada, Petição inicial trabalhista e Processo na íntegra.',
  defaultPecaRebater: 'Decisão do TST',
  pecaRebaterHelper: 'Informe a decisão do TST que apresenta divergência',
  infoTip: 'Nos embargos à SDI, demonstre a divergência jurisprudencial entre turmas do TST e fundamente o pedido de uniformização.',
};
export const EmbargosSdiTstForm = createFormFromConfig(EMBARGOS_SDI_TST_CONFIG);

// Memoriais Recursais Trabalhista
export const MEMORIAIS_RECURSAIS_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais (Trabalhista)',
  description: 'Peça para reforçar argumentos recursais em processo trabalhista',
  suggestedDocs: 'Acórdão, Processo na íntegra, Razões recursais e Sentença.',
  defaultPecaRebater: 'Razões Recursais',
  pecaRebaterHelper: 'Informe a peça ou razões que deseja reforçar',
  infoTip: 'Nos memoriais recursais, reforce os principais argumentos e jurisprudências favoráveis apresentadas nas razões.',
};
export const MemoriaisRecursaisTrabalhistaForm = createFormFromConfig(MEMORIAIS_RECURSAIS_TRABALHISTA_CONFIG);

// Recurso Extraordinário Trabalhista
export const RECURSO_EXTRAORDINARIO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Extraordinário (Trabalhista)',
  description: 'Recurso ao STF para questões constitucionais em processo trabalhista',
  suggestedDocs: 'Acórdão, Processo na íntegra e Decisão de admissibilidade.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Informe o acórdão que viola preceito constitucional',
  infoTip: 'No recurso extraordinário, demonstre claramente a ofensa à Constituição Federal e a repercussão geral da matéria.',
};
export const RecursoExtraordinarioTrabalhistaForm = createFormFromConfig(RECURSO_EXTRAORDINARIO_TRABALHISTA_CONFIG);

// Contrarrazões ao Recurso Extraordinário Trabalhista
export const CONTRARRAZOES_RE_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Extraordinário (Trabalhista)',
  description: 'Resposta ao Recurso Extraordinário em matéria trabalhista',
  suggestedDocs: 'Recurso Extraordinário, Acórdão recorrido e Processo na íntegra.',
  defaultPecaRebater: 'Recurso Extraordinário',
  pecaRebaterHelper: 'Informe o recurso extraordinário que deseja contrarrazoar',
  infoTip: 'Nas contrarrazões ao RE, demonstre a ausência de repercussão geral ou a inexistência de ofensa direta à Constituição.',
};
export const ContrarrazoesRETrabalhistaForm = createFormFromConfig(CONTRARRAZOES_RE_TRABALHISTA_CONFIG);

// Contraminuta ao Agravo de Instrumento Trabalhista
export const CONTRAMINUTA_AGRAVO_INSTRUMENTO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo de Instrumento (Trabalhista)',
  description: 'Resposta ao Agravo de Instrumento em matéria trabalhista',
  suggestedDocs: 'Agravo de instrumento, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo de Instrumento',
  pecaRebaterHelper: 'Informe o agravo de instrumento que deseja responder',
  infoTip: 'Na contraminuta, defenda a manutenção da decisão que negou seguimento ao recurso principal.',
};
export const ContraminutaAgravoInstrumentoTrabalhistaForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_INSTRUMENTO_TRABALHISTA_CONFIG);

// Contraminuta ao Agravo em Recurso Especial Trabalhista
export const CONTRAMINUTA_AGRAVO_RESP_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo em Recurso Especial',
  description: 'Resposta ao Agravo em Recurso Especial',
  suggestedDocs: 'Agravo em REsp, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo em Recurso Especial',
  pecaRebaterHelper: 'Informe o agravo que deseja responder',
  infoTip: 'Na contraminuta, demonstre que a decisão de inadmissibilidade do REsp deve ser mantida.',
};
export const ContraminutaAgravoRespTrabalhistaForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_RESP_TRABALHISTA_CONFIG);

// Contrarrazões aos Embargos de Declaração Trabalhista
export const CONTRARRAZOES_EMBARGOS_DECLARACAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões aos Embargos de Declaração',
  description: 'Resposta aos Embargos de Declaração opostos pela parte contrária',
  suggestedDocs: 'Decisão judicial, Embargos de declaração e Processo na íntegra.',
  defaultPecaRebater: 'Embargos de Declaração',
  pecaRebaterHelper: 'Informe os embargos que deseja responder',
  infoTip: 'Demonstre que não há omissão, contradição ou obscuridade na decisão embargada.',
};
export const ContrarrazoesEmbargosDeclaracaoTrabalhistaForm = createFormFromConfig(CONTRARRAZOES_EMBARGOS_DECLARACAO_TRABALHISTA_CONFIG);

// Ação Rescisória Trabalhista
export const ACAO_RESCISORIA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Ação Rescisória (Trabalhista)',
  description: 'Ação para desconstituir decisão transitada em julgado na justiça do trabalho',
  suggestedDocs: 'Processo original completo.',
  infoTip: 'Na ação rescisória, indique claramente o fundamento legal (art. 966 do CPC) para a desconstituição da coisa julgada.',
};
export const AcaoRescisoriaTrabalhistaForm = createFormFromConfig(ACAO_RESCISORIA_TRABALHISTA_CONFIG);

// Cumprimento de Sentença Trabalhista
export const CUMPRIMENTO_SENTENCA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Cumprimento de Sentença (Trabalhista)',
  description: 'Petição para iniciar a fase de execução da sentença trabalhista',
  suggestedDocs: 'Cálculos, Processo na íntegra e Sentença trabalhista.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Informe a sentença que será executada',
  infoTip: 'Apresente os cálculos atualizados e requeira as medidas executivas cabíveis.',
};
export const CumprimentoSentencaTrabalhistaForm = createFormFromConfig(CUMPRIMENTO_SENTENCA_TRABALHISTA_CONFIG);

// Impugnação ao Cumprimento de Sentença Trabalhista
export const IMPUGNACAO_CUMPRIMENTO_SENTENCA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação ao Cumprimento de Sentença',
  description: 'Defesa do executado na fase de cumprimento de sentença',
  suggestedDocs: 'Cálculos, Cumprimento de sentença e Processo na íntegra.',
  defaultPecaRebater: 'Cumprimento de Sentença',
  pecaRebaterHelper: 'Informe o pedido de cumprimento de sentença que deseja impugnar',
  infoTip: 'Aponte excesso de execução ou outras matérias de defesa permitidas na impugnação.',
};
export const ImpugnacaoCumprimentoSentencaTrabalhistaForm = createFormFromConfig(IMPUGNACAO_CUMPRIMENTO_SENTENCA_TRABALHISTA_CONFIG);

// Embargos à Execução Trabalhista
export const EMBARGOS_EXECUCAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos à Execução (Trabalhista)',
  description: 'Defesa do executado após a garantia do juízo',
  suggestedDocs: 'Decisão de penhora, Execução trabalhista e Planilha.',
  defaultPecaRebater: 'Petição de Execução',
  pecaRebaterHelper: 'Informe a execução que deseja embargar',
  infoTip: 'Nos embargos à execução, discuta matérias de defesa como excesso de penhora, avaliação incorreta ou nulidade da execução.',
};
export const EmbargosExecucaoTrabalhistaForm = createFormFromConfig(EMBARGOS_EXECUCAO_TRABALHISTA_CONFIG);

// Impugnação aos Embargos à Execução Trabalhista
export const IMPUGNACAO_EMBARGOS_EXECUCAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação aos Embargos à Execução',
  description: 'Resposta do exequente aos embargos do executado',
  suggestedDocs: 'Decisão e Embargos à execução.',
  defaultPecaRebater: 'Embargos à Execução',
  pecaRebaterHelper: 'Informe os embargos à execução que deseja responder',
  infoTip: 'Refute os argumentos do executado e requeira o prosseguimento da execução.',
};
export const ImpugnacaoEmbargosExecucaoTrabalhistaForm = createFormFromConfig(IMPUGNACAO_EMBARGOS_EXECUCAO_TRABALHISTA_CONFIG);

// Contrarrazões ao Agravo de Petição Trabalhista
export const CONTRARRAZOES_AGRAVO_PETICAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Agravo de Petição',
  description: 'Resposta ao Agravo de Petição interposto pela parte contrária',
  suggestedDocs: 'Agravo de Petição, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo de Petição Trabalhista',
  pecaRebaterHelper: 'Informe o agravo de petição que deseja contrarrazoar',
  infoTip: 'Nas contrarrazões, defenda a manutenção da decisão agravada na fase de execução.',
};
export const ContrarrazoesAgravoPeticaoForm = createFormFromConfig(CONTRARRAZOES_AGRAVO_PETICAO_CONFIG);

// Recurso Ordinário Constitucional Trabalhista
export const RECURSO_ORDINARIO_CONSTITUCIONAL_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Ordinário Constitucional',
  description: 'Recurso para o TST ou STF em casos específicos (ex: Mandado de Segurança)',
  suggestedDocs: 'Acórdão, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Decisão Denegatória',
  pecaRebaterHelper: 'Informe a decisão que denegou a ordem (ex: em MS)',
  infoTip: 'No ROC, demonstre o cabimento do recurso e as razões para reforma da decisão denegatória.',
};
export const RecursoOrdinarioConstitucionalTrabalhistaForm = createFormFromConfig(RECURSO_ORDINARIO_CONSTITUCIONAL_TRABALHISTA_CONFIG);

// Pedido de Cumprimento Provisório de Sentença Trabalhista
export const PEDIDO_CUMPRIMENTO_PROVISORIO_SENTENCA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Cumprimento Provisório de Sentença',
  description: 'Execução provisória da sentença pendente de recurso sem efeito suspensivo',
  suggestedDocs: 'Cálculos, Processo na íntegra e Sentença trabalhista.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Informe a sentença objeto do cumprimento provisório',
  infoTip: 'Requeira o início da execução provisória, apresentando os cálculos atualizados.',
};
export const PedidoCumprimentoProvisorioSentencaTrabalhistaForm = createFormFromConfig(PEDIDO_CUMPRIMENTO_PROVISORIO_SENTENCA_TRABALHISTA_CONFIG);

// Impugnação à Sentença de Homologação dos Cálculos Trabalhista
export const IMPUGNACAO_HOMOLOGACAO_CALCULOS_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Sentença de Homologação dos Cálculos',
  description: 'Manifestação discordando dos cálculos homologados pelo juiz',
  suggestedDocs: 'Processo na íntegra e Sentença homologatória de cálculos.',
  defaultPecaRebater: 'Sentença de Homologação dos Cálculos',
  pecaRebaterHelper: 'Informe a sentença que homologou os cálculos incorretos',
  infoTip: 'Aponte especificamente os erros de cálculo na sentença homologatória, sob pena de preclusão.',
};
export const ImpugnacaoHomologacaoCalculosTrabalhistaForm = createFormFromConfig(IMPUGNACAO_HOMOLOGACAO_CALCULOS_TRABALHISTA_CONFIG);

// Embargos à Ação Monitória Trabalhista
export const EMBARGOS_MONITORIA_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos à Ação Monitória (Trabalhista)',
  description: 'Defesa do réu na ação monitória trabalhista',
  suggestedDocs: 'Ação monitória, Comprovantes e Título.',
  defaultPecaRebater: 'Ação Monitória',
  pecaRebaterHelper: 'Informe a ação monitória que deseja embargar',
  infoTip: 'Nos embargos à monitória, alegue a inexistência da dívida ou a invalidade do documento escrito.',
};
export const EmbargosMonitoriaTrabalhistaForm = createFormFromConfig(EMBARGOS_MONITORIA_TRABALHISTA_CONFIG);

// Pedido de Penhora de Faturamento Trabalhista
export const PEDIDO_PENHORA_FATURAMENTO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Penhora de Faturamento',
  description: 'Requerimento de penhora sobre percentual do faturamento da empresa',
  suggestedDocs: 'Despacho para prosseguimento da execução, Documentos financeiros e Retorno de penhora infrutífera.',
  defaultPecaRebater: 'Despacho para prosseguimento da execução',
  pecaRebaterHelper: 'Informe o despacho que intimou para indicar meios de execução',
  infoTip: 'Demonstre a inexistência de outros bens penhoráveis e a viabilidade da penhora sobre o faturamento.',
};
export const PedidoPenhoraFaturamentoTrabalhistaForm = createFormFromConfig(PEDIDO_PENHORA_FATURAMENTO_TRABALHISTA_CONFIG);

// Pedido de Penhora no Rosto dos Autos Trabalhista
export const PEDIDO_PENHORA_ROSTO_AUTOS_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Penhora no Rosto dos Autos',
  description: 'Requerimento de penhora de crédito do devedor em outro processo',
  suggestedDocs: 'Cópia do processo onde existe o crédito e Processo de Execução.',
  defaultPecaRebater: 'Processo de Execução',
  pecaRebaterHelper: 'Informe o processo de execução onde se busca a satisfação do crédito',
  infoTip: 'Indique o número do processo onde o devedor possui crédito a receber para que seja averbada a penhora.',
};
export const PedidoPenhoraRostoAutosTrabalhistaForm = createFormFromConfig(PEDIDO_PENHORA_ROSTO_AUTOS_TRABALHISTA_CONFIG);

// Pedido de Expedição de RPV Trabalhista
export const PEDIDO_EXPEDICAO_RPV_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Expedição de RPV',
  description: 'Requerimento para pagamento de Requisição de Pequeno Valor',
  suggestedDocs: 'Cálculos homologados e Despacho.',
  defaultPecaRebater: 'Despacho',
  pecaRebaterHelper: 'Informe o despacho que determinou a expedição ou homologou cálculos',
  infoTip: 'Requeira a expedição da RPV após o trânsito em julgado da sentença de liquidação, observando o teto legal.',
};
export const PedidoExpedicaoRPVTrabalhistaForm = createFormFromConfig(PEDIDO_EXPEDICAO_RPV_TRABALHISTA_CONFIG);

// Pedido de Revisão Trabalhista
export const PEDIDO_REVISAO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Revisão',
  description: 'Requerimento para revisão de valor de benefício ou decisão',
  suggestedDocs: 'Processo na íntegra e Provas.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Informe o que objeto do pedido de revisão',
  infoTip: 'Fundamente o pedido de revisão demonstrando o erro de fato ou de direito na decisão ou cálculo anterior.',
};
export const PedidoRevisaoTrabalhistaForm = createFormFromConfig(PEDIDO_REVISAO_TRABALHISTA_CONFIG);

// Acordo Extrajudicial Trabalhista
export const ACORDO_EXTRAJUDICIAL_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Acordo Extrajudicial Trabalhista',
  description: 'Petição conjunta para homologação de acordo extrajudicial',
  suggestedDocs: 'Termo de acordo assinado, documentos das partes e procurações.',
  infoTip: 'No acordo extrajudicial, descreva os termos da transação, as verbas quitadas e a declaração de vontade das partes.',
};
export const AcordoExtrajudicialTrabalhistaForm = createFormFromConfig(ACORDO_EXTRAJUDICIAL_TRABALHISTA_CONFIG);

// Contraminuta ao Agravo Interno Trabalhista
export const CONTRAMINUTA_AGRAVO_INTERNO_TRABALHISTA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo Interno',
  description: 'Resposta ao agravo interno interposto contra decisão monocrática',
  suggestedDocs: 'Agravo interno e decisão agravada.',
  defaultPecaRebater: 'Agravo Interno',
  pecaRebaterHelper: 'Informe o agravo interno que deseja responder',
  infoTip: 'Defenda a decisão monocrática atacada, demonstrando que ela está em conformidade com a jurisprudência dominante.',
};
export const ContraminutaAgravoInternoTrabalhistaForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_INTERNO_TRABALHISTA_CONFIG);
